// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a94bd84","455":"53740411","977":"cd134f5c"}[chunkId] + ".chunk.js";
};